import Svg, { Path } from "react-native-svg"
import { useTheme } from "styled-rn"

import { IconProps } from "./SvgIcons"

export const BackArrow = (props: IconProps) => {
  const theme = useTheme()

  return (
    <Svg width={props.width} viewBox="0 0 10 10">
      <Path fill={theme[props.fill]} d="m2.207 4.5 3.147-3.146-.708-.708-4 4a.5.5 0 0 0 0 .708l4 4 .708-.708L2.207 5.5H10v-1H2.207Z" />
    </Svg>
  )
}
